module.exports = __webpack_public_path__ + "media/images/emblems/Walenstadt-coat_of_arms-6259f5d5808809df94e9ee464341de81.svg";